import { Box, Text, VStack } from 'native-base';
import Functions from '../../../utils/Functions';
import React from 'react';
import WhatNext from '../WhatNext';
const SHORTAGE_STATEMENT = `We have completed your annual escrow analysis and projected an account `;
const SHORTAGE_OF = 'shortage of ';
const STATEMENT_REASON = `. This means your local taxing authority or insurance company increased your required payment amount.`;
const SHORTAGE_SUMMARY_LINE_1 = `Freedom Mortgage does not set these amounts and simply acts on your behalf to pay these obligations. If you have questions about the amount due, please contact your taxing authority or insurance company.`;
const ShortageSummary = _ref => {
  let {
    amount,
    date,
    timeFrame
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(VStack, {
    space: 4,
    testID: "shortage-summary"
  }, /*#__PURE__*/React.createElement(Text, {
    fontSize: {
      base: 'sm',
      md: 'lg',
      lg: 'lg'
    },
    fontWeight: 300,
    color: '#222A34',
    accessibilityRole: "text",
    accessibilityLabel: `${SHORTAGE_STATEMENT}${SHORTAGE_OF}${Functions.toUSD(amount)}${STATEMENT_REASON}`
  }, SHORTAGE_STATEMENT, /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, SHORTAGE_OF, Functions.toUSD(amount)), STATEMENT_REASON), /*#__PURE__*/React.createElement(Text, {
    italic: true,
    fontSize: {
      base: 'sm',
      md: 'lg',
      lg: 'lg'
    },
    fontWeight: 300,
    color: '#222A34',
    accessibilityLabel: SHORTAGE_SUMMARY_LINE_1,
    accessibilityRole: "text"
  }, SHORTAGE_SUMMARY_LINE_1)), /*#__PURE__*/React.createElement(WhatNext, {
    date: date,
    amount: amount,
    type: 'shortage',
    timeFrame: timeFrame
  }));
};
export default ShortageSummary;
//# sourceMappingURL=index.js.map